// All the possible actions that can happen on pageload mpn-check.
export enum Action {
  None = 0,
  GoToAccountSetupPage = 1,
  GoToHomePage = 2,
  ShowTermsAndConditionsAcceptance = 3,
  ShowPartnerDistributionId = 4,
  ShowGenericErrorDialog = 5 // if anything goes wrong, show a generic error dialog
}
